/*
 * Copyright (c) 2024. Tooling Team
 */

import {
  getMvdRowState,
  ROW_STATE_BADGE_CLASSES,
  ROW_STATE_LABELS,
} from "./rowState";

export default function RowStateCellRenderer(params) {
  const { data } = params.node;
  const rowState = getMvdRowState(data);

  if (!rowState) {
    return <span></span>;
  }

  return (
    <span className={`badge ${ROW_STATE_BADGE_CLASSES[rowState]} w-100`}>
      {ROW_STATE_LABELS[rowState]}
    </span>
  );
}
